import React from 'react';
import {withFormik, FieldArray} from 'formik';
import {
  createRolePermissionsBox,
  appendMatchingProgram,
  hasNoRestrictedProgram,
} from './utils';
import {InlineSelect} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {
  Divider,
  Card,
  Grid,
  Icon,
  Form,
  Button,
  Header,
  Checkbox,
} from 'semantic-ui-react';
import * as Yup from 'yup';
import _ from 'lodash';
import {
  ROLE_MAP,
  SUBRECIPIENT_ROLES_LABEL,
  NONSUBRECIPENT_ROLES_LABEL,
  ENTITY_MAP,
} from 'app-ui-componentlibrary/dist/common/constants';

export const InnerForm = ({
  values,
  setFieldValue,
  setActiveRole,
  setActiveParent,
  setActivePrograms,
  activeRole,
  setEdit,
  editMode,
  role_opts,
  orgName,
  userId,
  userNotFound,
  createUser,
  renderMemberInfo,
  getUserData,
  originalUser,
  selectedUser,
  updateUser,
  closeManageTeamModal,
  isAORUser,
  programs,
  assignedPrograms,
  parentOrgs,
  orgTeamRoles,
  setSelectedPrograms,
  selectedPrograms,
  orgs,
  renderType,
  subOrgToggle,
  permissions,
  selectedOrgId,
  userEntities,
  displayNameParent,
  parentOrgId,
  selectUnselectAll,
  selectUnselectProgram,
  loginuserId,
  showValidationError,
}) => {
  var programsGroupedByCategory = _.chain(programs)
    .groupBy('programCategoryName')
    .map(function (value, key) {
      return {
        categoryName: key,
        programsList: value,
      };
    })
    .value();

  const AOR_ROLE = values.user.map((r) => r.roleId === 1);

  const isSARUsr = (role) => {
    return (
      selectedUser &&
      loginuserId === selectedUser.userId &&
      role === ROLE_MAP.SUBAUTHREP.label
    );
  };

  // Checks organization ACL for the logged in user to operate on selected user
  const canOperate = (user) => {
    let canEditoOrDelete = true;
    // logged user org list
    let loggedUserOrgLst = [false];

    permissions.forEach((permission) => {
      let [entityTypeId, entityId, roleId] = permission.split(':');
      if (entityTypeId == ENTITY_MAP.ORGANIZATION.code) {
        loggedUserOrgLst.push(true);
      }
    });

    // logged in user with out Org level acess can not manage selected user that has org level ACL.
    if (
      !loggedUserOrgLst.includes(true) &&
      user.entityTypeId === ENTITY_MAP.ORGANIZATION.code
    )
      canEditoOrDelete = false;

    return canEditoOrDelete;
  };

  let options = [];

  if (orgs != undefined) {
    const matchingOrgs = _.filter(parentOrgs, (org) =>
      _.includes(orgs, org.organizationId)
    );

    options = _.map(matchingOrgs, (org) => {
      return {
        value: org.organizationId,
        text: org.displayName,
      };
    });
  } else {
    options = _.map(parentOrgs, (entry) => {
      return {
        value: entry.organizationId,
        text: entry.displayName,
      };
    });
  }

  var subprogramsGroupedByCategory = _.chain(
    _.filter(programs, {subapplicationFlag: true})
  )
    .groupBy('programCategoryName')
    .map(function (value, key) {
      return {
        categoryName: key,
        programsList: value,
      };
    })
    .value();

  const role_opts_suborg = _.filter(
    role_opts[orgName],
    (role) =>
      role.value == ROLE_MAP.SUBAUTHREP.label || role.value == ROLE_MAP.SUBMEMBER.label
  );

  const activeRow = _.get(values.user, activeRole);

  let disabled_flag = activeRow != undefined;

  let filtermatchedProgram = null;
  let filtermatchedProgramList = [];
  let entityIdList = [];
  let filterentityIdBySelectedOrgIdList = [];
  let filterentityIdbyparentList = [];
  let filtersubprogramsGroupedByCategory = [];

  const canHaveSubOrganizations = userEntities
    .filter((y) => {
      return y.entityId === selectedOrgId;
    })
    .map((x) => {
      return x.canHaveSuborganizations;
    })[0];

  if (_.get(activeRow, 'parent') != undefined && !canHaveSubOrganizations) {
    const parentId = activeRow.parent;

    permissions.forEach((permission) => {
      let [entityTypeId, entityId, roleId] = permission.split(':');

      if (entityTypeId == ENTITY_MAP.PROGRAM_ORGANIZATION_SUBORGANIZATION.code) {
        entityIdList.push(entityId);
      }
    });

    {
      entityIdList.forEach((entityId) => {
        let [orgId, prgId, subOrgId] = entityId.split('_');

        if (subOrgId == selectedOrgId) {
          filterentityIdBySelectedOrgIdList.push(entityId);
        }
      });

      filterentityIdBySelectedOrgIdList.forEach((entityId) => {
        let [orgId, prgId, subOrgId] = entityId.split('_');

        if (orgId == parentId) {
          filterentityIdbyparentList.push(entityId);
        }
      });

      let programsList = [];

      filterentityIdbyparentList.forEach((entityId) => {
        let [orgId, prgId, subOrgId] = entityId.split('_');
        programsList.push(prgId);
      });

      _.forEach(programsList, (obj) => {
        filtermatchedProgram = _.filter(programs, (program) => program.programId == obj);
        filtermatchedProgramList.push(filtermatchedProgram);
      });

      filtersubprogramsGroupedByCategory = _.chain(
        _.filter(_.flatten(filtermatchedProgramList), {
          subapplicationFlag: true,
        })
      )
        .groupBy('programCategoryName')
        .map(function (value, key) {
          return {
            categoryName: key,
            programsList: value,
          };
        })
        .value();
    }
  } else {
    filtersubprogramsGroupedByCategory = _.chain(
      _.filter(programs, {subapplicationFlag: true})
    )
      .groupBy('programCategoryName')
      .map(function (value, key) {
        return {
          categoryName: key,
          programsList: value,
        };
      })
      .value();
  }

  if (
    subOrgToggle &&
    activeRow &&
    SUBRECIPIENT_ROLES_LABEL.includes(activeRow.roles) &&
    activeRow.parent &&
    activeRow.parent != ''
  ) {
    if (
      SUBRECIPIENT_ROLES_LABEL.includes(activeRow.roles) &&
      activeRow.programs.length == 0
    ) {
      disabled_flag = true;
    } else {
      disabled_flag = false;
    }
  }

  if (
    subOrgToggle &&
    activeRow &&
    NONSUBRECIPENT_ROLES_LABEL.includes(activeRow.roles) &&
    activeRow.roles != ''
  ) {
    disabled_flag = false;
  }

  if (!subOrgToggle) {
    disabled_flag =
      values.user.length && values.user.filter((user) => !user.roles).length;
  }

  return (
    <React.Fragment>
      {subOrgToggle && !selectedUser && values.user.length >= 1 ? (
        <div id="instructions">
          <strong>
            Assign roles{renderType == 'subOrg' && subOrgToggle && ' and programs'}
          </strong>
          <br />
          <p>
            Choose a role
            {renderType == 'subOrg' &&
              subOrgToggle &&
              ' and set of programs the user has permissions for by selecting the programs from the list'}
            .
          </p>
          <Divider />
        </div>
      ) : (
        values.user.length !== 0 && (
          <div id="instructions">
            <strong>Assign{renderType == 'subOrg' && 'ed'} roles and programs</strong>
            <br />
            <p>
              Choose a role. You can limit this role to a set of programs by selecting the
              programs from the list. If you are an AOR not limited by programs and the
              user you are adding can have access to all the programs, then you do not
              need to select any program(s).
            </p>
            <Divider />
          </div>
        )
      )}
      <Form id="org-team-form">
        <FieldArray
          name="user"
          render={(arrayHelpers) => (
            <React.Fragment>
              {values.user &&
                values.user.length > 0 &&
                values.user.map((section, index) =>
                  index === activeRole ? (
                    <div
                      key={`user_${index}_${values.user[index].roles}}`}
                      className="roles-container"
                    >
                      <div className="action-container">
                        {editMode && !disabled_flag && (
                          <div
                            onClick={() => {
                              setActiveRole(null);
                              setActiveParent(null);
                              setActivePrograms(null);
                              setEdit(false);
                            }}
                          >
                            <Icon className="close-icon" name="delete" color="blue" />
                            <a title="Close" className="editIcon" color="blue">
                              Close
                            </a>
                          </div>
                        )}
                        {(index > 0 || selectedUser) &&
                        (!AOR_ROLE[index] || !isAORUser) ? (
                          <React.Fragment>
                            <Icon
                              onClick={() => {
                                arrayHelpers.remove(index);
                                setActiveRole(null);
                                setActiveParent(null);
                                setActivePrograms(null);
                                setEdit(false);
                              }}
                              className="action-icon"
                              name="delete"
                              color="blue"
                            />
                            <a
                              onClick={() => {
                                arrayHelpers.remove(index);
                                setActiveRole(null);
                                setActiveParent(null);
                                setActivePrograms(null);
                                setEdit(false);
                              }}
                              title="Delete role"
                              className="deleteIcon"
                              color="blue"
                            >
                              Delete
                            </a>
                          </React.Fragment>
                        ) : null}
                      </div>
                      <InlineSelect
                        size="medium"
                        title="Required: Role"
                        guidance={`Role ${index + 1}`}
                        id="user_roles"
                        name={`user[${index}].roles`}
                        options={
                          (subOrgToggle && renderType == 'subOrg' && role_opts_suborg) ||
                          role_opts[orgName]
                        }
                        defaultValue="Select"
                        value={values.user[index].roles}
                        handleChange={(e) => {
                          setFieldValue('entity', orgName);
                          const data = e.target;

                          if (data && data.name) {
                            setFieldValue(`user[${index}].roles`, data.value);
                          }
                          setFieldValue(`user[${index}].programs`, []);
                          setFieldValue(`user[${index}].parent`, undefined);
                          setFieldValue(
                            `user[${index}].entityTypeId`,
                            ENTITY_MAP.ORGANIZATION.code
                          );
                        }}
                      />
                      {subOrgToggle ? (
                        values.user[index].roles === ROLE_MAP.SUBMEMBER.label ||
                        values.user[index].roles === ROLE_MAP.SUBAUTHREP.label ? (
                          renderType == 'subOrg' ? (
                            values.user[index].parent != parentOrgId ? (
                              setFieldValue(`user[${index}].parent`, parentOrgId) &&
                              setFieldValue(
                                `user[${index}].entityTypeId`,
                                ENTITY_MAP.PROGRAM_ORGANIZATION_SUBORGANIZATION.code
                              )
                            ) : null
                          ) : (
                            <React.Fragment>
                              <InlineSelect
                                size="medium"
                                title="Required: Parent Organization"
                                guidance={`Select Parent Organization ${index + 1}`}
                                id="user_parentOrgs"
                                name={`user[${index}].parent`}
                                displayError={
                                  !activeRow.parent &&
                                  SUBRECIPIENT_ROLES_LABEL.includes(activeRow.roles)
                                }
                                errorMessages="A response is required"
                                options={options}
                                defaultValue="Select"
                                value={values.user[index].parent}
                                handleChange={(e) => {
                                  const data = e.target;
                                  if (data && data.name) {
                                    setFieldValue(`user[${index}].parent`, data.value);
                                    setFieldValue(
                                      `user[${index}].parentText`,
                                      data.innerText.substr(6, data.innerText.length)
                                    );
                                  }
                                  setFieldValue(`user[${index}].programs`, []);
                                  setFieldValue(
                                    `user[${index}].entityTypeId`,
                                    ENTITY_MAP.PROGRAM_ORGANIZATION_SUBORGANIZATION.code
                                  );
                                }}
                              />
                            </React.Fragment>
                          )
                        ) : null
                      ) : null}
                      {subOrgToggle ? (
                        <React.Fragment>
                          <div id="programs-section">
                            {renderType === 'subOrg' ||
                            values.user[index].roles === ROLE_MAP.SUBMEMBER.label ||
                            values.user[index].roles === ROLE_MAP.SUBAUTHREP.label ? (
                              <Header as="h4" className="programs-header">
                                <b> Assign programs </b>
                              </Header>
                            ) : (
                              <Header as="h4" className="programs-header">
                                Assign program(s) (optional){' '}
                              </Header>
                            )}
                            <div
                              className={
                                SUBRECIPIENT_ROLES_LABEL.includes(activeRow.roles) &&
                                (activeRow.programs.length == 0) != ''
                                  ? 'errorBorderLine'
                                  : ''
                              }
                            >
                              <div id="programs-list-container">
                                <FieldArray
                                  name={`user[${index}].programs`}
                                  render={(arrayHelpers) => (
                                    <span>
                                      {renderType == 'subOrg' ||
                                      (!values.user[index].parent &&
                                        (values.user[index].roles ===
                                          ROLE_MAP.SUBMEMBER.label ||
                                          values.user[index].roles ===
                                            ROLE_MAP.SUBAUTHREP.label))
                                        ? _.map(
                                            subprogramsGroupedByCategory,
                                            (categoryId, pos) => {
                                              return (
                                                <div>
                                                  <div className="programs-list">
                                                    <Checkbox
                                                      id={`selectprogram_${pos}`}
                                                      className="container select-all"
                                                      onClick={(e) =>
                                                        selectUnselectAll(
                                                          e,
                                                          values,
                                                          index,
                                                          categoryId,
                                                          setSelectedPrograms
                                                        )
                                                      }
                                                      checked={_.reduce(
                                                        categoryId.programsList,
                                                        (condition, p) =>
                                                          condition &&
                                                          _.findIndex(
                                                            values.user[index].programs,
                                                            {programId: p.programId}
                                                          ) != -1,
                                                        true
                                                      )}
                                                      label={categoryId.categoryName}
                                                    />
                                                  </div>
                                                  <Divider />

                                                  {
                                                    // check if parent is not selected. do programList
                                                    // if parent is selected. do filterprogamListbyParent- do conditional operator.

                                                    _.map(
                                                      categoryId.programsList,
                                                      (programsList, pos) => {
                                                        const {
                                                          programId,
                                                          programDescription,
                                                          programName,
                                                        } = programsList;

                                                        return (
                                                          <div
                                                            className="programs-list"
                                                            key={`${programName}_${pos}_${index}`}
                                                          >
                                                            <Checkbox
                                                              id={`mitigationprogram_${programId}`}
                                                              className="container programCheckbox"
                                                              name={`${programDescription} (${programName})`}
                                                              value={programId}
                                                              onClick={(e) =>
                                                                selectUnselectProgram(
                                                                  e,
                                                                  values,
                                                                  index,
                                                                  programId,
                                                                  arrayHelpers
                                                                )
                                                              }
                                                              checked={_.some(
                                                                values.user[index]
                                                                  .programs,
                                                                {
                                                                  programId: programId,
                                                                }
                                                              )}
                                                              label={`${programDescription} (${programName})`}
                                                            />
                                                          </div>
                                                        );
                                                      }
                                                    )
                                                  }
                                                  <br />
                                                  <Divider />
                                                </div>
                                              );
                                            }
                                          )
                                        : values.user[index].parent &&
                                          (values.user[index].roles ===
                                            ROLE_MAP.SUBMEMBER.label ||
                                            values.user[index].roles ===
                                              ROLE_MAP.SUBAUTHREP.label)
                                        ? _.map(
                                            filtersubprogramsGroupedByCategory,
                                            (categoryId, pos) => {
                                              return (
                                                <div>
                                                  <div className="programs-list">
                                                    <Checkbox
                                                      id={`selectprogram_${pos}`}
                                                      className="container select-all"
                                                      onClick={(e) =>
                                                        selectUnselectAll(
                                                          e,
                                                          values,
                                                          index,
                                                          categoryId,
                                                          setSelectedPrograms
                                                        )
                                                      }
                                                      checked={_.reduce(
                                                        categoryId.programsList,
                                                        (condition, p) =>
                                                          condition &&
                                                          _.findIndex(
                                                            values.user[index].programs,
                                                            {programId: p.programId}
                                                          ) != -1,
                                                        true
                                                      )}
                                                      label={categoryId.categoryName}
                                                    />
                                                  </div>
                                                  <Divider />

                                                  {_.map(
                                                    categoryId.programsList,
                                                    (programsList, pos) => {
                                                      const {
                                                        programId,
                                                        programDescription,
                                                        programName,
                                                      } = programsList;

                                                      return (
                                                        <div
                                                          className="programs-list"
                                                          key={`${programName}_${pos}_${index}`}
                                                        >
                                                          <Checkbox
                                                            id={`mitigationprogram_${programId}`}
                                                            className="container programCheckbox"
                                                            name={`${programDescription} (${programName})`}
                                                            value={programId}
                                                            onClick={(e) =>
                                                              selectUnselectProgram(
                                                                e,
                                                                values,
                                                                index,
                                                                programId,
                                                                arrayHelpers
                                                              )
                                                            }
                                                            checked={_.some(
                                                              values.user[index].programs,
                                                              {
                                                                programId: programId,
                                                              }
                                                            )}
                                                            label={`${programDescription} (${programName})`}
                                                          />
                                                        </div>
                                                      );
                                                    }
                                                  )}
                                                  <br />
                                                  <Divider />
                                                </div>
                                              );
                                            }
                                          )
                                        : // aor role when toggle is on
                                          _.map(
                                            programsGroupedByCategory,
                                            (categoryId, pos) => {
                                              return (
                                                <div>
                                                  <div className="programs-list">
                                                    <Checkbox
                                                      id={`selectprogram_${pos}`}
                                                      className="container select-all"
                                                      onClick={(e) =>
                                                        selectUnselectAll(
                                                          e,
                                                          values,
                                                          index,
                                                          categoryId,
                                                          setSelectedPrograms
                                                        )
                                                      }
                                                      checked={_.reduce(
                                                        categoryId.programsList,
                                                        (condition, p) =>
                                                          condition &&
                                                          _.findIndex(
                                                            values.user[index].programs,
                                                            {programId: p.programId}
                                                          ) != -1,
                                                        true
                                                      )}
                                                      label={categoryId.categoryName}
                                                    />
                                                  </div>
                                                  <Divider />
                                                  {_.map(
                                                    categoryId.programsList,
                                                    (programsList, pos) => {
                                                      const {
                                                        programId,
                                                        programDescription,
                                                        programName,
                                                      } = programsList;
                                                      return (
                                                        <div
                                                          className="programs-list"
                                                          key={`${programName}_${pos}_${index}`}
                                                        >
                                                          <Checkbox
                                                            id={`mitigationprogram_${programId}`}
                                                            className="container programCheckbox"
                                                            name={`${programDescription}`}
                                                            value={programId}
                                                            onClick={(e) =>
                                                              selectUnselectProgram(
                                                                e,
                                                                values,
                                                                index,
                                                                programId,
                                                                arrayHelpers
                                                              )
                                                            }
                                                            checked={_.some(
                                                              values.user[index].programs,
                                                              {
                                                                programId: programId,
                                                              }
                                                            )}
                                                            label={`${programName}`}
                                                          />
                                                        </div>
                                                      );
                                                    }
                                                  )}
                                                  <br />
                                                  <Divider />
                                                </div>
                                              );
                                            }
                                          )}

                                      <br />
                                    </span>
                                  )}
                                />
                              </div>
                              {SUBRECIPIENT_ROLES_LABEL.includes(activeRow.roles) &&
                              activeRow.programs.length == 0 ? (
                                <p class="errorMessages">A response is required</p>
                              ) : null}
                            </div>
                          </div>
                        </React.Fragment>
                      ) : (
                        ''
                      )}
                    </div>
                  ) : (
                    <Card fluid key={'user' + index} id="roleProgram-details">
                      <Grid celled="internally" fluid>
                        <Grid.Column width={14} className="left-side">
                          <Grid celled="internally" fluid row={2}>
                            <Grid.Column>
                              <strong>{`Role ${index + 1}`}</strong>
                              <div>
                                {!selectedUser
                                  ? role_opts[orgName].find(
                                      (opt) => opt.value === values.user[index].roles
                                    )
                                    ? role_opts[orgName].find(
                                        (opt) => opt.value === values.user[index].roles
                                      ).text
                                    : 'Loading...'
                                  : values.user[index].roles}
                              </div>
                            </Grid.Column>
                          </Grid>
                          {subOrgToggle && renderType !== 'subOrg' ? (
                            SUBRECIPIENT_ROLES_LABEL.includes(
                              values.user[index].roles
                            ) ? (
                              <React.Fragment>
                                <hr />
                                <Grid celled="internally" fluid row={2}>
                                  <Grid.Column>
                                    <strong>{`Parent Organization`}</strong>
                                    <div>
                                      {displayNameParent(
                                        values.user[index].parent,
                                        parentOrgs
                                      )}
                                    </div>
                                  </Grid.Column>
                                </Grid>
                              </React.Fragment>
                            ) : null
                          ) : null}
                          {subOrgToggle ? (
                            <React.Fragment>
                              <hr />
                              <Grid celled="internally" fluid row={2}>
                                <Grid.Column>
                                  <strong>Programs</strong>
                                  <div>
                                    {values.user[index].programs.length > 0
                                      ? values.user[index].programs
                                          .map((currentProgram) =>
                                            appendMatchingProgram(
                                              assignedPrograms,
                                              programs,
                                              currentProgram
                                            )
                                          )
                                          .join(', ')
                                      : 'All programs'}
                                  </div>
                                </Grid.Column>
                              </Grid>
                            </React.Fragment>
                          ) : (
                            ''
                          )}
                        </Grid.Column>
                        <Grid.Column width={2} className="right-side">
                          <Grid columns={1}>
                            <Grid.Column width="10">
                              {hasNoRestrictedProgram(
                                programs,
                                values.user[index].programs
                              ) &&
                              canOperate(values.user[index]) &&
                              (index >= 0 || selectedUser) &&
                              ((!AOR_ROLE[index] &&
                                !isSARUsr(values.user[index].roles)) ||
                                (!isAORUser && !isSARUsr(values.user[index].roles))) ? (
                                <div
                                  onClick={(e) => {
                                    e.preventDefault();
                                    if (values.user[values.user.length - 1].roles) {
                                      setActiveRole(index);
                                      setActiveParent(index);
                                      setActivePrograms(index);
                                    } else {
                                      arrayHelpers.remove(values.user.length - 1);
                                      setActiveRole(index);
                                      setActiveParent(index);
                                      setActivePrograms(index);
                                    }
                                    setEdit(true);
                                  }}
                                >
                                  <Icon
                                    className="action-icon"
                                    name="pencil"
                                    color="blue"
                                  />
                                  <a
                                    title="Edit role and programs"
                                    className="editIcon"
                                    color="blue"
                                    tabIndex={0}
                                    href="#"
                                  >
                                    Edit
                                  </a>
                                </div>
                              ) : null}
                              {hasNoRestrictedProgram(
                                programs,
                                values.user[index].programs
                              ) &&
                              canOperate(values.user[index]) &&
                              (index >= 0 || selectedUser) &&
                              ((!AOR_ROLE[index] &&
                                !isSARUsr(values.user[index].roles)) ||
                                (!isAORUser && !isSARUsr(values.user[index].roles))) ? (
                                <div
                                  onClick={async (e) => {
                                    e.preventDefault();
                                    setActiveRole(null);
                                    setActiveParent(null);
                                    setActivePrograms(null);
                                    setEdit(false);
                                    if (values.user[values.user.length - 1].roles) {
                                      arrayHelpers.remove(index);
                                    } else {
                                      arrayHelpers.remove(values.user.length - 1);
                                      arrayHelpers.remove(index);
                                    }
                                  }}
                                >
                                  <Icon
                                    className="action-icon"
                                    name="delete"
                                    color="blue"
                                  />
                                  <a
                                    title="Delete role and programs"
                                    className="deleteIcon"
                                    color="blue"
                                    tabIndex={0}
                                    href="#"
                                  >
                                    Delete
                                  </a>
                                </div>
                              ) : null}
                            </Grid.Column>
                          </Grid>
                        </Grid.Column>
                      </Grid>
                    </Card>
                  )
                )}
              {values.user.length >= 1 ? (
                <React.Fragment>
                  <Divider className="hr-dotted" />
                  <Button
                    primary
                    basic
                    id="addRole"
                    name="addRole"
                    onClick={(e) => {
                      e.preventDefault();
                      setEdit(false);
                      setActiveRole(values.user.length);
                      setActiveParent(values.user.length);
                      const newForm = {roles: '', parent: '', programs: []};
                      arrayHelpers.push(newForm);
                    }}
                    disabled={disabled_flag}
                  >
                    <Icon name="plus" />
                    {'Add another role'}
                  </Button>
                  <br />
                  <br />
                  {createRolePermissionsBox(orgTeamRoles, subOrgToggle)}
                </React.Fragment>
              ) : null}
              {showValidationError && (
                <p style={{color: 'red'}}>
                  Unable to save the updated permissions without an assigned program.
                </p>
              )}
              {!selectedUser ? (
                <Button
                  primary
                  compact
                  id="addTeamMember"
                  name="addTeamMember"
                  disabled={values.user[0].roles === ''}
                  onClick={() => {
                    setEdit(false);
                    createUser(userId, values);
                  }}
                  disabled={disabled_flag}
                >
                  {renderType === 'subOrg' ? 'Add this user' : 'Add this team member'}
                  <Icon name="check" size="small" />
                </Button>
              ) : (
                <Button
                  primary
                  compact
                  id="saveAndClose"
                  name="saveAndClose"
                  onClick={() => {
                    setEdit(false);
                    updateUser(selectedUser, values);
                  }}
                  disabled={disabled_flag}
                >
                  {values.user.length >= 1 ? (
                    <span>Save &amp; close</span>
                  ) : (
                    <span>Delete user</span>
                  )}

                  <Icon name="check" size="small" />
                </Button>
              )}
            </React.Fragment>
          )}
        />
      </Form>
    </React.Fragment>
  );
};

export const withSemanticUIFormik = (props, values) => (WrappedComponent) => {
  return withFormik(
    props,
    values
  )(
    class extends React.Component {
      constructor(props) {
        super(props);
        this.state = {
          activeRole: !this.props.selectedUser ? 0 : null,
          activePrograms: !this.props.selectedUser ? 0 : null,
          activeParent: !this.props.selectedUser ? 0 : null,
          programSelected: false,
          selectedPrograms: [],
        };
      }

      setSelectedPrograms = (value) => {
        this.setState({
          selectedPrograms: value,
        });
      };
      setActiveRole = (value) => {
        this.setState({activeRole: value});
      };
      setActiveParent = (value) => {
        this.setState({activeParent: value});
      };
      setActivePrograms = (value) => {
        this.setState({activePrograms: value});
      };
      setEdit = (value) => {
        this.setState({editMode: value});
      };

      render() {
        return (
          <WrappedComponent
            {...this.props}
            roles={this.props.roles}
            programs={this.props.programs}
            orgName={this.props.orgName}
            setFieldValue={this.props.setFieldValue}
            role_opts={this.props.role_opts}
            isAORUser={this.props.isAORUser}
            activeRole={this.state.activeRole}
            setActiveRole={this.setActiveRole}
            setActiveParent={this.setActiveParent}
            setSelectedPrograms={this.setSelectedPrograms}
            setActivePrograms={this.setActivePrograms}
            editMode={this.state.editMode}
            setEdit={this.setEdit}
            userId={this.props.userId}
            userNotFound={this.props.userNotFound}
            createUser={this.props.createUser}
            renderMemberInfo={this.props.renderMemberInfo}
            getUserData={this.props.getUserData}
            selectedUser={this.props.selectedUser}
            updateUser={this.props.updateUser}
            openManageTeamModal={this.props.openManageTeamModal}
            closeManageTeamModal={this.props.closeManageTeamModal}
            parentOrgs={this.props.parentOrgs}
            SuborgProgram={this.props.SuborgProgram}
            orgTeamRoles={this.props.orgTeamRoles}
          />
        );
      }
    }
  );
};

const userValidation = Yup.object().shape({
  user: Yup.array().of(
    Yup.object().shape({
      roles: Yup.string().required(),
    })
  ),
});

export const RoleAndProgramForm = withSemanticUIFormik({
  mapPropsToValues: ({originalUser, selectedUser}) => {
    return {
      originalUser:
        originalUser && originalUser.roles.length
          ? originalUser.roles.map((r) => ({
              roleId: r.roleId,
              roles: r.description,
              parent: r.parentOrgId,
              programs: r.programs || [],
              entityTypeId: r.parentOrgId
                ? ENTITY_MAP.PROGRAM_ORGANIZATION_SUBORGANIZATION.code
                : r.programs && r.programs.length > 0
                ? ENTITY_MAP.PROGRAM_ORGANIZATION.code
                : ENTITY_MAP.ORGANIZATION.code,
            }))
          : [
              {
                roles: '',
                parent: '',
                programs: [],
              },
            ],
      user:
        selectedUser && selectedUser.roles.length
          ? selectedUser.roles.map((r) => ({
              roleId: r.roleId,
              roles: r.description,
              parent: r.parentOrgId,
              programs: r.programs || [],
              entityTypeId: r.parentOrgId
                ? ENTITY_MAP.PROGRAM_ORGANIZATION_SUBORGANIZATION.code
                : r.programs && r.programs.length > 0
                ? ENTITY_MAP.PROGRAM_ORGANIZATION.code
                : ENTITY_MAP.ORGANIZATION.code,
            }))
          : [
              {
                roles: '',
                parent: '',
                programs: [],
              },
            ],
    };
  },

  validationSchema: userValidation,

  handleSubmit: async (values, {props, setSubmitting}) => {
    setSubmitting(true);
  },
})(InnerForm);

export default RoleAndProgramForm;
